export default "__VITE_ASSET__VqlPNsg3__"